<template>
  <div class="myinfo">
<!--    <div class="tips">-->
<!--      <i class="iconfont icon-shuoming"></i-->
<!--      >请输入您需要找回密码的姓名和账户，我们会将新密码通过邮件的方式发送到您的邮箱-->
<!--    </div>-->
     <div class="tips">
      <p>
        <i class="iconfont icon-shuoming"></i>
        如忘记账户，请联系客服：400-801-0928
      </p>
    </div>
    <div class="form-horizontal myform">
      <div class="input-group">
        <span class="input-group-addon"><span style="color: red">* </span>姓名: </span>
        <input
          type="text"
          class="form-control"
          aria-describedby="basic-addon1"
          v-model="name"
          placeholder="请输入姓名"
        />
      </div>
      <div class="input-group">
        <span class="input-group-addon"><span style="color: red">* </span>账户: </span>
        <input
          type="text"
          class="form-control"
          aria-describedby="basic-addon1"
          v-model="username"
          placeholder="请输入账户"
        />
      </div>
      <div class="input-group">
        <span class="input-group-addon"><span style="color: red">* </span>身份证号: </span>
        <input
          type="text"
          class="form-control"
          aria-describedby="basic-addon1"
          v-model="idNo"
          placeholder="请输入身份证号"
        />
      </div>
      <div class="input-group">
        <span class="input-group-addon"><span style="color: red">* </span>手机号: </span>
        <input
          type="text"
          class="form-control"
          aria-describedby="basic-addon1"
          v-model="phone"
          placeholder="请输入手机号"
        />
      </div>
      <div class="input-group">
        <span class="input-group-addon"><span style="color: red">* </span>图形验证码: </span>
        <input
          type="text"
          class="form-control"
          placeholder="请输入图形验证码"
          aria-describedby="basic-addon1"
          v-model="captcha"
        />
        <img :src="imageCode" @click="getRandomImage" />
      </div>
      <div class="input-group">
        <span class="input-group-addon"><span style="color: red">* </span>手机验证码: </span>
          <input
            type="text"
            class="form-control"
            v-model="phoneVerifyCode"
            aria-describedby="basic-addon1"
            placeholder="请输入手机验证码"
          />
          <button type="button" style="margin-left: 10px" class="btn btn-default form-control sub" @click="getSmsVerifyCode" :disabled="smsDisabled">
            {{ smsMessage }}
          </button>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <button
            type="submit"
            @click="submit"
            class="btn btn-default form-control sub"
          >
          <!-- 忘记密码提交 -->
            提交
          </button>
          <div style="text-align: right; margin: 10px; color: #1890ff">
            <span style="cursor: pointer" @click="gotoLogin">返回登录</span>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      :visible="showFlag"
      title=""
      :maskClosable="false"
      :closable="false"
      :footer="null"
      :width="300"
    >
      <div style="margin: 20px 10px">
        <span></span><br />
        <span>点击确定按钮跳转到登录页面</span>
      </div>
      <a-button type="primary" style="width: 100%" @click="gotoLogin">确定</a-button>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'userBindTel',
  data: function () {
    return {
      randomCode: null,
      imageCode: `/static/images/checkcode.png`,
      uuid: null,
      captcha: '',
      phone: '',
      sms: '',
      archives: [],
      userid: null,
      username: null,
      name: null,
      showFlag: false,
      idNo: '',
      phoneVerifyCode: '',
      smsMessage: `获取短信验证码`,
      smsDisabled: false
    }
  },
  mounted() {
    this.name = null
    this.captcha = null
    this.username = null
    this.idNo = ''
    const number = parseInt(Math.random(1) * Math.pow(10, 10))
    this.randomCode = number
    this.getRandomImage() // 获取图形验证码
  },
  methods: {

    getRandomImage() {
      this.axios.get(`/sys/randomImage/${this.randomCode}`).then((res) => {
        this.imageCode = res.result
      })
    },
    gotoLogin() {
      this.showFlag = false
      this.$router.push('login')
    },

    // 获取短信验证码
    getSmsVerifyCode() {
      if (!this.check()) {
        return
      }
      this.axios
        .post(`/sys/sms`, {
          captcha: this.captcha,
          checkKey: this.randomCode,
          mobile: this.phone
        }).then((res) => {
          if (res.success) {
            this.$message.success('发送成功')
            this.countdown(300)
          } else {
            this.getRandomImage()
          }
        }).catch(() => {
          this.getRandomImage()
        })
    },

    check() {
      var myregPhone = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/
      var myregIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (!this.name) {
        this.$message.warning('请输入姓名')
        return false
      } else if (!this.username) {
        this.$message.warning('请输入账户')
        return false
      } else if (!this.idNo) {
        this.$message.warning('请输入身份证号')
        return false
      } else if (!myregIdNo.test(this.idNo)) {
        this.$message.warning('身份证号格式不正确')
        return false
      } else if (!this.phone) {
        this.$message.warning('请输入手机号')
        return false
      } else if (!myregPhone.test(this.phone)) {
        this.$message.warning('手机号格式不正确')
        return false
      } else if (!this.captcha) {
        this.$message.warning('请输入图形验证码')
        return false
      } else {
        return true
      }
    },
    // 倒计时
    countdown(index) {
      let countdownData = index
      this.smsDisabled = true
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        if (countdownData >= 0) {
          this.smsMessage = `${countdownData}秒后重试`
          countdownData--
        } else {
          this.smsMessage = `获取短信验证码`
          this.smsDisabled = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
    submit() {
      if (!this.check()) {
        return
      }
      if (!this.phoneVerifyCode) {
        this.$message.warning('请输入手机验证码')
        return
      }
      this.axios.get(`/biz/user/userBindTel`, {
        params: {
          name: this.name,
          username: this.username,
          idNo: this.idNo,
          phone: this.phone,
          phoneVerifyCode: this.phoneVerifyCode
        }
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.result)
          this.gotoLogin()
        }
      }).catch((e) => {
        this.countdown(0)
        this.randomCode = parseInt(Math.random(1) * Math.pow(10, 10))
        this.getRandomImage()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.myinfo {
  padding: 18px;
  margin-top: 00px;
}

.myform {
  width: 460 px;
  margin: 0 auto;
  background: none;
  color: #999;

  .input-group {
    margin-bottom: 20px;
  }

  .input-group-addon {
    display: inline-block;
    width: 100px;
    text-align: right;
    line-height: 33px;
    margin-right: 10px;
  }

  .sub {
    background: $bgColor;
    color: #fff;
  }
}

.icon-shuoming {
  color: $bgColor;
}

.tips {
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/userbind/components/UserBindTel.vue